// Envia o formulário público sem colocar o e-mail de destino no site.
// A chave aponta para a caixa configurada na conta do Web3Forms.

const ACCESS_KEY = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY;

async function postToWeb3Forms(fields) {
    if (!ACCESS_KEY) {
        const error = new Error('Envio de contato indisponível.');
        error.code = 'MISSING_KEY';
        throw error;
    }

    const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify({
            from_name: 'Higeia.tech',
            ...fields,
            access_key: ACCESS_KEY,
            botcheck: fields.botcheck || '',
        }),
    });

    let data = {};
    try {
        data = await response.json();
    } catch {
        data = {};
    }

    if (!response.ok || data.success === false) {
        throw new Error(data.message || 'Não foi possível enviar a mensagem.');
    }

    return data;
}

export async function sendContactMessage({ name, email, phone, subject, message, botcheck }) {
    return postToWeb3Forms({
        subject: `Contato pelo site — ${subject}`,
        name,
        email,
        phone: phone || 'Não informado',
        message,
        botcheck,
    });
}

export async function sendDemoRequest({ nome, email, telefone, nomeLar, residentes, origem, botcheck }) {
    const detalhes = [
        `Nome: ${nome}`,
        `E-mail: ${email}`,
        `Telefone: ${telefone || 'Não informado'}`,
        `Lar: ${nomeLar || 'Não informado'}`,
        `Residentes/leitos: ${residentes || 'Não informado'}`,
        origem ? `Página: ${origem}` : null,
    ].filter(Boolean);

    return postToWeb3Forms({
        subject: `Demonstração — ${nome}`,
        name: nome,
        email,
        phone: telefone || 'Não informado',
        message: detalhes.join('\n'),
        botcheck,
    });
}
